<template>
  <div class="col-lg-10 col-md-12 mx-auto">
    <!-- <b-toast
      variant="secondary"
      id="attivato-abb"
      title="Attivato!"
      static
      no-close-button
      class="text-center mx-auto"
      body-class="text-gray-dark"
    >
      <p class="text-justify mx-auto mb-0">Abbonamento attivato</p>
    </b-toast>-->
    <h3>Lista utenti registrati</h3>
    <div class="col-12 mx-auto">
      <b-form-select v-model="only" :options="filters" @change="getUsers"></b-form-select>
    </div>
    <div class="col-12 mx-auto d-flex font-weight-bold mt-3">
      <span class="ml-0 mr-auto col-3">Email</span>
      <span class="ml-0 mr-auto col-2">Tipologia</span>
      <span class="ml-0 mr-auto col-1">Ruolo</span>
      <span class="ml-0 mr-auto col-4">Abbonamento</span>
      <span class="ml-0 mr-auto col-2"></span>
    </div>
    <div
      class="col-12 d-flex align-items-center no-wrap mx-auto my-2"
      v-for="(user,ind) in users"
      :key="ind"
    >
      <span class="text-left text-secondary font-weight-bold col-3 ml-0 mr-auto">{{user.email}}</span>
      <span class="text-left text-secondary font-weight-bold col-2 ml-0 mr-auto">{{user.tipologia}}</span>
      <span class="text-left text-secondary font-weight-bold col-1 ml-0 mr-auto">{{user.role}}</span>
      <div class="col-4 mx-auto" v-if="user.tipologia === 'professionista'">
        <span
          v-if="user.abbonamento"
          class="text-left text-secondary font-weight-bold ml-0 mr-auto"
        >{{ user.abbonamento.slug }}</span>
        <span
          v-else
          class="text-left text-orange font-weight-bold ml-0 mr-auto"
        >nessun abbonamento attivo</span>
        <!-- <b-form-group>
          <b-form-radio
            v-for="(abb,ind) in abbonamenti"
            :key="ind"
            v-model="form.abbonamento_hash_id"
            name="abbonamenti"
            :value="abb.hashid"
          >{{abb.slug}}</b-form-radio>
        </b-form-group>-->
      </div>
      <div v-else class="col-4 mx-auto"></div>
      <div class="col-2 mx-auto">
        <b-button class="col" variant="secondary" @click="showModal(user)">Dettagli</b-button>
      </div>
    </div>
    <b-modal
      ref="dettaglio"
      size="xl"
      title="Dettagli Utente"
      scrollable
      centered
      header-bg-variant="secondary"
      header-text-variant="white font-weight-bold"
      cancel-disabled
      ok-disabled
      ok-only
    >
      <dettaglio-utente :utente="selectedUser" :abb="abbonamenti" />
    </b-modal>
  </div>
</template>
<script>
import DettaglioUtente from "@/components/admin/DettaglioUtente";
import moment from "moment";
export default {
  name: "ListaUtenti",
  components: { DettaglioUtente },
  data() {
    return {
      users: null,
      abbonamenti: null,
      // form: {
      //   abbonamento_hash_id: null,
      //   user_hash_id: null,
      //   attivo: true,
      //   data_inizio: null
      // },
      filters: [
        { text: "tutti gli utenti", value: null },
        { text: "professionisti", value: "professionista" },
        { text: "pazienti", value: "paziente" }
      ],
      only: null,
      selectedUser: null
    };
  },
  methods: {
    getUsers() {
      var url = process.env.VUE_APP_VERSION + "admin/allusers";
      if (this.only) {
        url = process.env.VUE_APP_VERSION + "admin/allusers?only=" + this.only;
      }
      this.$axios
        .get(url)
        .then(res => {
          // console.log(res.data.data);
          this.users = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getAbbonamenti() {
      var url = process.env.VUE_APP_VERSION + "admin/abbonamenti";
      this.$axios
        .get(url)
        .then(res => {
          // console.log(res.data.data);
          this.abbonamenti = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    showModal(rif) {
      this.selectedUser = rif;
      this.$refs["dettaglio"].show();
    },
    hideModal() {
      this.selectedUser = null;
      this.$refs["dettaglio"].hide();
    }
    // attiva(user) {
    //   var url = process.env.VUE_APP_VERSION + "admin/abbonamenti-utente";
    //   this.form.data_inizio = moment().format("YYYY-MM-DD");
    //   this.form.user_hash_id = user.hashid;
    //   console.log(this.form);
    //   this.$axios
    //     .post(url, this.form)
    //     .then(res => {
    //       console.log(res.data.data);
    //       this.form = {
    //         abbonamento_hash_id: null,
    //         user_hash_id: null,
    //         attivo: true,
    //         data_inizio: null
    //       };
    //       this.$bvToast.show("attivato-abb");
    //     })
    //     .catch(err => {
    //       this.msg = err;
    //       if (err.response.status === 401) {
    //         this.$router.go();
    //       }
    //     });
    // }
  },
  created() {
    this.getUsers();
    this.getAbbonamenti();
  }
};
</script>